import { type ApiResponse } from '~/shared/http-client/exceptions/type'

export type Filters = {
  category_code?: string
  page: number
  row_per_page: number
}

export type Category = {
  id: number
  code: string
  name: string
  description: string
  sorting: number
  category_id: number
  category_code: string
  option_1: string
  option_2: string
  option_3: string
  option_4: string
}

export type CategoryResponse = {
  categoryList: Category[]
}

export type CategoryTabOptions = {
  value: string
  label: string
}

export interface CategoryApiResponse extends ApiResponse {
  data: CategoryResponse
}

export type PageInfo = {
  page: number
  row_per_page: number
  total_count: number
  max_page: number
  keyword: string
  category: string
  sort: string
  search: Record<string, unknown>
  category_code: string
}

export type Inquiry = {
  id: number
  user_id: number
  status: string
  status_desc: string
  category: string
  title: string
  body: string
  imageObj: ImageObj
  created_at: string
  updated_at: string
  commonList?: string | null
  category_desc: string
}

export type InquiryResponse = {
  pageInfo: PageInfo
  list: Inquiry[]
}

export interface InquiryApiResponse extends ApiResponse {
  data: InquiryResponse
}

export type NavigationObject = {
  id: number
  event_id: number
  read_count: number
  category: string
  status: string
  title: string
  body: string
}

export type NavigationInfo = {
  prevIdx: number
  prevObj: NavigationObject
  nextIdx: number
  nextObj: NavigationObject
}

export type ImageObj = {
  id: number
  parent_table_key: number
  original_name: string
  url: string
}

export type Comment = {
  id: number
  inquiry_id: number
  admin_name: string
  comment: string
  created_at: string
  updated_at: string
}

export type InquiryDetailInfo = {
  id: number
  user_id: number
  status: string
  category: string
  title: string
  body: string
  image: string
  created_at: string
  updated_at: string
  category_desc: string
  status_desc: string
  imageObj: ImageObj
  commentList?: Comment[] | null
}

export type InquiryDetailResponse = {
  info: InquiryDetailInfo
  navigationInfo: NavigationInfo
}

export interface InquiryDetailApiResponse extends ApiResponse {
  data: InquiryDetailResponse
}

export const InquiryTabs = {
  FAQ: 'faq',
  INQUIRY: 'inquiry',
} as const

export const InquiryTabLabels: { [key in InquiryTab]: string } = {
  faq: 'FAQ',
  inquiry: '1:1 문의',
}

export type InquiryTab = (typeof InquiryTabs)[keyof typeof InquiryTabs]

export type InquiryRequest = {
  id?: number
  title: string
  body: string
  category: string
  image?: number | number[]
}

export type InquiryInfo = {
  id: number
  user_id: number
  status: string
  category: string
  title: string
  body: string
  image: string
  created_at: string
  updated_at: string
  category_desc: string
  commonList?: string | null
}

export type InquiryInfoResponse = {
  info: InquiryInfo
}

export interface InquiryInfoApiResponse extends ApiResponse {
  data: InquiryInfoResponse
}
